// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hfgTrG5GWScTC8Pcbx18 {
  position: relative;
  text-align: center
}
.MbUqmTJE9uEDX0f7DvXZ {
  position: absolute;
  right: 1.5rem;
  display: flex;
  cursor: pointer;
  align-items: center;
  border-color: none;
  font-size: 1.25rem;
  line-height: 1.75rem;
  background: transparent
}
.Nr3K_UQRkM3yeWMarFak {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  display: flex;
  justify-content: center;
  gap: 1rem
}
.gR4Y_ekKTH8vNqxjcCk9 {
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700
}
.mpfgsB3YVRc87ccWibx6 {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center
}
.BXrk9I89gveVpCU3NSxH {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}
.Cuta78NYTo26aEY5ZvgS {
  margin: auto;
  display: flex;
  height: 45px;
  width: 250px !important;
  justify-content: center;
  --tw-bg-opacity: 1;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
.Cuta78NYTo26aEY5ZvgS:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
.ncLOrFaqJjsQ3ebppOJU {
  margin-bottom: 15px;
  height: 44px;
  width: 250px;
  border-radius: 5px !important;
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1))
}

.ncLOrFaqJjsQ3ebppOJU:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1))
}

.JuO3bYSoJOTuWVqDpuZs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1));
  padding: 1.5rem
}

.jkXVKhanMLRnIPwU7eQR {
  font-family: Noto Sans;
  font-size: 18px;
  font-weight: 600
}

.ozLSqr34usgu4iC4iDWM {
  display: flex;
  height: 35px;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1));
  font-family: Noto Sans
}
.XS03I59gWzg9G_OBnPXf {
  margin-left: 1.5rem;
  font-size: 14px;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}

.Z9IRRy6c4dz7I26cOYMI {
  margin-right: 1.5rem;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 500
}

.pWVAvTqwFatX_DrA2A7r {
  display: flex;
  height: 59px;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity, 1));
  font-family: Noto Sans
}
.mdzGPz2TyVbs20e6CYBe {
  margin-left: 1.5rem;
  font-family: Noto Sans;
  font-size: 14px;
  --tw-text-opacity: 1;
  color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}
.kNoE6c8xZ_RksXgnxorw {
  margin-right: 1.5rem;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}
.FvNX5nYfMd6NPIskF_AQ {
  display: flex;
  height: 59px;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1))
}
.MpEK_eB4usbMiryOsAYF {
  margin-left: 1.5rem;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.i4CMYU2SAjFhtGh9Hdgj {
  margin-right: 1.5rem;
  font-size: 14px;
  font-weight: 700;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.KzDmC4dXE8IiwNcfA04k {
  padding: 2rem
}
`, "",{"version":3,"sources":["webpack://./src/components/Pledge/SummaryModal/SummaryModal.module.css"],"names":[],"mappings":"AACE;EAAA,kBAA2B;EAA3B;AAA2B;AAG3B;EAAA,kBAA8E;EAA9E,aAA8E;EAA9E,aAA8E;EAA9E,eAA8E;EAA9E,mBAA8E;EAA9E,kBAA8E;EAA9E,kBAA8E;EAA9E,oBAA8E;EAC9E;AAD8E;AAI9E;EAAA,kBAAsC;EAAtC,qBAAsC;EAAtC,aAAsC;EAAtC,uBAAsC;EAAtC;AAAsC;AAGtC;EAAA,mBAAyB;EAAzB,oBAAyB;EAAzB;AAAyB;AAGzB;EAAA,gBAAsD;EAAtD,aAAsD;EAAtD,sBAAsD;EAAtD,mBAAsD;EAAtD;AAAsD;AAGtD;EAAA,aAAkG;EAAlG,sBAAkG;EAAlG,mBAAkG;EAAlG,uBAAkG;EAAlG,iBAAkG;EAAlG,oBAAkG;EAAlG,sBAAkG;EAAlG,eAAkG;EAAlG,gBAAkG;EAAlG,oBAAkG;EAAlG;AAAkG;AAGlG;EAAA,YAA6E;EAA7E,aAA6E;EAA7E,YAA6E;EAA7E,uBAA6E;EAA7E,uBAA6E;EAA7E,kBAA6E;EAA7E,0DAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAG7E;EAAA,6BAAgC;EAAhC,qEAAgC;EAAhC,+BAAgC;EAAhC;AAAgC;AAGhC;EAAA,mBAAmE;EAAnE,YAAmE;EAAnE,YAAmE;EAAnE,6BAAmE;EAAnE,kBAAmE;EAAnE;AAAmE;;AAInE;EAAA,kBAAuB;EAAvB;AAAuB;;AAIvB;EAAA,aAAqE;EAArE,mBAAqE;EAArE,8BAAqE;EAArE,wBAAqE;EAArE,sBAAqE;EAArE,4DAAqE;EAArE;AAAqE;;AAIrE;EAAA,sBAAiC;EAAjC,eAAiC;EAAjC;AAAiC;;AAIjC;EAAA,aAAqF;EAArF,YAAqF;EAArF,mBAAqF;EAArF,8BAAqF;EAArF,wBAAqF;EAArF,sBAAqF;EAArF,4DAAqF;EAArF;AAAqF;AAGrF;EAAA,mBAAmD;EAAnD,eAAmD;EAAnD,gBAAmD;EAAnD,oBAAmD;EAAnD;AAAmD;;AAInD;EAAA,oBAA4D;EAA5D,sBAA4D;EAA5D,eAA4D;EAA5D;AAA4D;;AAI5D;EAAA,aAAsG;EAAtG,YAAsG;EAAtG,mBAAsG;EAAtG,8BAAsG;EAAtG,wBAAsG;EAAtG,sBAAsG;EAAtG,4DAAsG;EAAtG,kBAAsG;EAAtG,4DAAsG;EAAtG;AAAsG;AAGtG;EAAA,mBAAuD;EAAvD,sBAAuD;EAAvD,eAAuD;EAAvD,oBAAuD;EAAvD;AAAuD;AAGvD;EAAA,oBAAyE;EAAzE,sBAAyE;EAAzE,eAAyE;EAAzE,gBAAyE;EAAzE,oBAAyE;EAAzE;AAAyE;AAGzE;EAAA,aAA0E;EAA1E,YAA0E;EAA1E,mBAA0E;EAA1E,8BAA0E;EAA1E,wBAA0E;EAA1E,sBAA0E;EAA1E;AAA0E;AAG1E;EAAA,mBAA+D;EAA/D,sBAA+D;EAA/D,eAA+D;EAA/D,gBAA+D;EAA/D,oBAA+D;EAA/D;AAA+D;AAG/D;EAAA,oBAAkE;EAAlE,eAAkE;EAAlE,gBAAkE;EAAlE,gDAAkE;EAAlE,oBAAkE;EAAlE;AAAkE;AAGlE;EAAA;AAAU","sourcesContent":[".otpModal {\n  @apply relative text-center;\n}\n.closeBtn {\n  @apply absolute text-xl cursor-pointer border-[none] right-6 flex items-center;\n  background: transparent;\n}\n.otpWrapper {\n  @apply flex justify-center gap-4 my-10;\n}\n.header {\n  @apply text-3xl font-bold;\n}\n.modalContainer {\n  @apply flex flex-col justify-center items-center  mt-8;\n}\n.infoContainer {\n  @apply flex flex-col justify-center items-center text-gray-400 font-body text-body font-inter py-4;\n}\n.applyButton {\n  @apply flex bg-secondary text-white !w-[250px] h-[45px] justify-center m-auto;\n}\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n.customInput {\n  @apply bg-amountInputBG w-[250px] h-[44px] !rounded-[5px] mb-[15px];\n}\n\n.customInput:hover {\n  @apply bg-amountInputBG;\n}\n\n.titleGroup {\n  @apply flex justify-between items-center border-b border-gray-200 p-6;\n}\n\n.title {\n  @apply text-h4 font-h4 font-inter;\n}\n\n.customTable {\n  @apply border-b border-gray-200 h-[35px] flex justify-between items-center font-inter;\n}\n.paymentDetails {\n  @apply text-primary text-dashboardMain font-h3 ml-6;\n}\n\n.ticketNumber {\n  @apply mr-6 font-dashboardMain text-dashboardMain font-inter;\n}\n\n.customTableColumn {\n  @apply border-b border-gray-200 h-[59px] flex justify-between items-center bg-customTableBG font-inter;\n}\n.tableLabel {\n  @apply text-dashboardMain text-gray-400 ml-6 font-inter;\n}\n.tableValue {\n  @apply text-gray-600 text-dashboardMain font-dashboardSub mr-6 font-inter;\n}\n.transactionColumn {\n  @apply border-b border-gray-200 h-[59px] flex justify-between items-center;\n}\n.netPayable {\n  @apply text-dashboardMain font-h4 text-gray-500 font-inter ml-6;\n}\n.payableValue {\n  @apply text-gray-600 text-dashboardMain font-h3 text-gray-500 mr-6;\n}\n.buttonGroup {\n  @apply p-8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"otpModal": `hfgTrG5GWScTC8Pcbx18`,
	"closeBtn": `MbUqmTJE9uEDX0f7DvXZ`,
	"otpWrapper": `Nr3K_UQRkM3yeWMarFak`,
	"header": `gR4Y_ekKTH8vNqxjcCk9`,
	"modalContainer": `mpfgsB3YVRc87ccWibx6`,
	"infoContainer": `BXrk9I89gveVpCU3NSxH`,
	"applyButton": `Cuta78NYTo26aEY5ZvgS`,
	"customInput": `ncLOrFaqJjsQ3ebppOJU`,
	"titleGroup": `JuO3bYSoJOTuWVqDpuZs`,
	"title": `jkXVKhanMLRnIPwU7eQR`,
	"customTable": `ozLSqr34usgu4iC4iDWM`,
	"paymentDetails": `XS03I59gWzg9G_OBnPXf`,
	"ticketNumber": `Z9IRRy6c4dz7I26cOYMI`,
	"customTableColumn": `pWVAvTqwFatX_DrA2A7r`,
	"tableLabel": `mdzGPz2TyVbs20e6CYBe`,
	"tableValue": `kNoE6c8xZ_RksXgnxorw`,
	"transactionColumn": `FvNX5nYfMd6NPIskF_AQ`,
	"netPayable": `MpEK_eB4usbMiryOsAYF`,
	"payableValue": `i4CMYU2SAjFhtGh9Hdgj`,
	"buttonGroup": `KzDmC4dXE8IiwNcfA04k`
};
export default ___CSS_LOADER_EXPORT___;
